import { useQualificationContext } from 'shared/helpers/QualificationContext';

import { SellerLeadFragment as Lead } from 'sellDirect/graphql/fragments/__generated__/SellerLeadFragment';

/**
 * A convenience method to extract deeply nested contact info
 * in a safe way.
 */
export const getLeadInfo = (
  lead?: Lead | null,
): {
  email: string | undefined;
  phone: string | undefined;
  name: string;
  customerUUID: string;
} => ({
  email: lead?.customerV2?.primaryEmail?.address?.value,
  phone: lead?.customerV2?.primaryPhoneNumber?.number?.value,
  name: lead?.customerV2?.fullName || '',
  customerUUID: lead?.customerV2?.uuid || '',
});

/**
 * A hook around `useQualificationContext` that returns common
 * calendly related info.
 */
export const useCalendlyParams = () => {
  const { lead, sellerInputUUID } = useQualificationContext();
  const { email, phone, name } = getLeadInfo(lead);

  return {
    email,
    phone,
    name,
    utm_content: `seller_input_uuid:${sellerInputUUID}`,
    utm_source: 'seller_dashboard',
  };
};
